/** Saved return paths that should not override role-based routing */
function isUsableRequestedPath(path: string | undefined | null): boolean {
  if (!path || typeof path !== 'string') {
    return false;
  }
  const trimmed = path.trim();
  if (!trimmed || trimmed === '/') {
    return false;
  }
  if (trimmed === '/login' || trimmed.startsWith('/login/')) {
    return false;
  }
  return true;
}

/** Email-code login passes `user`; password login passes `{ user }` from the API */
function userFromLoginPayload(
  payload: { user?: { provider?: { status?: string } }; provider?: { status?: string } } | undefined | null
): { provider?: { status?: string } } | null {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  if ('user' in payload && payload.user && typeof payload.user === 'object') {
    return payload.user;
  }
  return payload as { provider?: { status?: string } };
}

export function getDefaultDashboardPathForUser(
  user: { provider?: { status?: string } } | undefined | null
): string {
  if (user?.provider?.status && user.provider.status !== 'incomplete') {
    return '/dashboard';
  }
  return '/customer-dashboard';
}

/**
 * After login: use a saved deep link when safe, otherwise provider vs customer home.
 * `loginPayload` may be the user document or `{ user }` (password login).
 */
export function getPostLoginRedirectUrl(
  loginPayload: { user?: { provider?: { status?: string } }; provider?: { status?: string } } | undefined | null,
  pathRequested: string | undefined | null
): string {
  if (isUsableRequestedPath(pathRequested)) {
    return pathRequested!.trim();
  }
  return getDefaultDashboardPathForUser(userFromLoginPayload(loginPayload));
}
